// extracted by mini-css-extract-plugin
export default {"signIn":"SignIn_signIn__-OqFM","form":"SignIn_form__FLPJU","form__group":"SignIn_form__group__eqrdI"};